import { styled } from '@mui/material/styles';
import { Box, BoxProps, Container, ContainerProps } from '@mui/material';

export const HeaderShowed = styled(Box)<BoxProps>(({ theme }) => ({
    position: 'relative',
    margin: '8px',
    paddingBottom: '40px',
    zIndex: 1,

    [theme.breakpoints.up('sm')]: {
        margin: '12px',
    },

    [theme.breakpoints.up('md')]: {
        paddingBottom: '0',
    },
}));

export const HeaderNotShowed = styled(Box)<BoxProps>(({ theme }) => ({
    borderTop: `12px solid ${theme.palette.primary.main}`,
}));

export const HeaderInner = styled(Container, {
    shouldForwardProp: (prop) => prop !== 'withBgImage',
})<ContainerProps & { withBgImage?: boolean }>(({ theme, withBgImage }) => ({
    position: 'relative',
    paddingBottom: '20px',
    paddingTop: '20px',
    height: '90px',
    borderRadius: '8px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundColor: theme.palette.primary.main,

    ...(!withBgImage && {
        '&::before': {
            content: "''",
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '8px',
            background: 'linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%)',
        },
    }),

    [theme.breakpoints.up('md')]: {
        height: '160px',
    },
}));

export const AppHeaderLogo = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '120px',
    height: '120px',
    padding: '4px',
    borderRadius: '8px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04)',

    [theme.breakpoints.up('md')]: {
        width: '160px',
        height: '160px',
        margin: '50px 0 0',
        padding: '6px',
    },
}));

export const AppHeaderLogoImg = styled('img')({
    maxWidth: '100%',
    display: 'block',
    borderRadius: '6px',
});
